import { CustomPlotlineElement, ExtendedPlotline } from './index'
import Clusters from '../clusters'

export default function HoverArea(plotline: ExtendedPlotline): CustomPlotlineElement {
    const chart = plotline.axis.chart
    const isInverted = chart.inverted
    const { id, onChangePosition } = plotline.options
    const marker = plotline.linePath!
    const menu = plotline.menuButton!

    // Hover area has an area of 30px.
    // 15px in each side of the actual marker
    const x = isInverted ? marker.start.x : marker.start.x - 15
    const y = isInverted ? marker.start.y - 15 : marker.start.y
    const width = isInverted ? marker.end.x - marker.start.x : 30
    const height = isInverted ? 30 : marker.end.y - marker.start.y

    const hoverArea: CustomPlotlineElement = chart.renderer
        .rect(x, y, width, height)
        .attr({
            stroke: 'blue',
            fill: 'blue',
            zIndex: 11,
            class: 'marker-extended-area',
            opacity: 0, // change to 0.4 to see the hover area
            id: id + '-area'
        })
        .on('mouseover', function () {
            if (id === 'placeholder') return

            menu.attr({ visibility: 'visible' })
            Clusters.setHighlight(plotline, true)
        })
        .on('mouseout', function () {
            if (id !== 'placeholder') menu.attr({ visibility: 'hidden' })
        })
        .on('click', function (evt: MouseEvent) {
            // edit draft position v2
            // if (id === 'placeholder') return
            // evt.targetRuler = plotline.options.data
        })
        .add()

    hoverArea.update = function ({ linePath }, hide) {
        const width = isInverted ? linePath.end.x - linePath.start.x : 30
        const height = isInverted ? 30 : linePath.end.y - linePath.start.y

        if (isInverted) {
            this.attr({ width, height, y: linePath.start.y - 15, visibility: hide ? 'hidden' : 'visible' })
        } else {
            this.attr({ width, height, x: linePath.start.x - 15, visibility: hide ? 'hidden' : 'visible' })
        }

        return null
    }

    hoverArea.destroy = function (this: CustomPlotlineElement) {
        this.update = () => null

        return Object.getPrototypeOf(this).destroy.call(this)
    }

    return hoverArea
}
